import React from 'react';
import { Compass, Sun, Trees, MapPin } from 'lucide-react';
import { LIFE_STATS, LIFE_BULLETS, IMG } from '../mock/mock';

const BULLET_ICONS = [Sun, Sun, Compass, Compass, Trees];

export default function LakeLife() {
  return (
    <section id="eleterzes" className="relative py-24 md:py-32 bg-gradient-to-b from-[#faf7f1] via-[#fbf8f3] to-[#f5f0e8] overflow-hidden">
      {/* subtle horizontal lines pattern */}
      <div aria-hidden className="absolute inset-0 opacity-[0.4] pointer-events-none" style={{backgroundImage:'linear-gradient(to bottom, transparent 0px, transparent 60px, rgba(13,35,54,0.04) 60px, rgba(13,35,54,0.04) 61px)', backgroundSize:'100% 61px'}} />
      {/* big watermark 03 */}
      <div aria-hidden className="absolute left-0 top-1/2 -translate-y-1/2 pointer-events-none select-none">
        <span className="font-serif-display text-[280px] md:text-[420px] leading-none text-[#1a1a1a]/[0.035]">03</span>
      </div>

      <div className="relative max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-12 gap-12 items-start mb-14">
          <div className="lg:col-span-6">
            <div className="flex items-center gap-3 mb-6">
              <span className="section-num text-[#2BA8C0] text-2xl">03</span>
              <span className="text-[12px] uppercase tracking-[0.3em] text-[#7a7a7a] font-medium">Életérzés a tónál</span>
            </div>
            <h2 className="font-serif-display text-4xl md:text-6xl text-[#1a1a1a] leading-[1.05]">
              Ébredjen a víz<br /><span className="italic text-[#2BA8C0]">csillogására.</span>
            </h2>
          </div>
          <div className="lg:col-span-6 grid grid-cols-3 gap-3 lg:pt-12">
            {LIFE_STATS.map((s) => (
              <div key={s.label} className="bg-white rounded-2xl p-5 text-center shadow-[0_2px_15px_rgba(13,35,54,0.04)]">
                <div className="font-serif-display text-3xl text-[#1a1a1a] mb-1">{s.value}</div>
                <div className="text-[10px] uppercase tracking-wider text-[#7a7a7a]">{s.label}</div>
              </div>
            ))}
          </div>
        </div>

        <div className="grid lg:grid-cols-12 gap-10 lg:gap-14 items-start">
          {/* Left: image collage */}
          <div className="lg:col-span-6 relative h-[520px]">
            <div className="absolute top-0 left-0 w-[68%] h-[70%] rounded-3xl overflow-hidden shadow-xl">
              <img src={IMG.finished} alt="" className="w-full h-full object-cover" />
              <div className="absolute bottom-4 left-4 bg-white/95 backdrop-blur px-3 py-1.5 rounded-full">
                <span className="text-[11px] uppercase tracking-wider text-[#2BA8C0] font-semibold">Velencei-tó</span>
              </div>
            </div>
            <div className="absolute bottom-0 right-0 w-[55%] h-[60%] rounded-3xl overflow-hidden shadow-2xl border-4 border-[#f5f0e8]">
              <img src={IMG.tiles} alt="" className="w-full h-full object-cover" />
            </div>
          </div>

          {/* Right: content */}
          <div className="lg:col-span-6">
            <p className="text-[#3a3a3a] text-[16px] leading-relaxed mb-7">
              Az Eco-Lak otthonok nem csak házak — egy életforma. A Velencei-tó környékén
              minden reggel a természet nyugalmával kezdődik, minden este a naplemente aranyával zárul.
            </p>

            <blockquote className="border-l-2 border-[#2BA8C0] pl-5 py-1 italic text-[#3a3a3a] text-[15px] leading-relaxed mb-8">
              &ldquo;Amikor megérkeztem a Velencei-tó partjára, tudtam, hogy itt akarok élni. Az Eco-Lak ezt lehetővé tette.&rdquo;
              <footer className="mt-2 not-italic text-[12px] uppercase tracking-wider text-[#9a9a9a]">— Családi referencia, Gárdony</footer>
            </blockquote>

            <ul className="space-y-3">
              {LIFE_BULLETS.map((b, i) => {
                const Icon = BULLET_ICONS[i] || Compass;
                return (
                  <li key={i} className="bg-white border border-[#ece7df] rounded-2xl px-5 py-3.5 flex items-center gap-3 shadow-[0_1px_8px_rgba(13,35,54,0.03)]">
                    <span className="w-8 h-8 rounded-full bg-[#2BA8C0]/10 flex items-center justify-center shrink-0">
                      <Icon className="w-4 h-4 text-[#2BA8C0]" />
                    </span>
                    <span className="text-[#3a3a3a] text-[14px]">{b}</span>
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
